import React from 'react';
import './CVBarman.scss';
import Profil from '../../assets/use.jpg';

export default function CVBarman() {
  return (
    <div className="cv-container">
      {/* Header avec Photo Profil */}
      <header className="cv-header">
        <div className="profile-wrapper">
          <img 
            src={Profil}
            alt="Profil Barman" 
            className="profile-img"
          />
        </div>
        {/* <span className="badge-tag">Management & Mixologie</span> */}
        <h1 className="main-title">Maël BOILEVE</h1>
        <p className="job-title">Barman • Serveur • Manager</p>
      </header>

      {/* Introduction */}
      <section className="intro-card">
        <p className="intro-text">
          Professionnel du bar dynamique et rigoureux, j'évolue au sein d'un établissement à fort débit où j'assure la gestion opérationnelle et le management d'équipe. Formé à la mixologie et à la tenue d'un bar, je mets mon sens des priorités et mon souci du détail au service d'une organisation efficace et d'une expérience client irréprochable.
        </p>
      </section>

      {/* Compétences (Bento Grid Visuel) */}
      <section className="cv-section">
        <h2 className="section-title">Savoir-Faire & Compétences</h2>
        <div className="bento-grid">
          
          <div className="bento-card card-with-img">
            <div className="card-media">
              <img src="https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=600&q=80" alt="Cocktail Mixologie" />
            </div>
            <div className="card-content">
              <span className="card-label">Création & Carte</span>
              <h3>Mixologie & Cartes</h3>
              <p>Mise en place et organisation du bar, création de cocktails signature, équilibre des saveurs et élaboration de cartes sur-mesure.</p>
            </div>
          </div>

          <div className="bento-card card-with-img">
            <div className="card-media">
              <img src="https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=600&q=80" alt="Cave et stocks" />
            </div>
            <div className="card-content">
              <span className="card-label">Gestion Opérationnelle</span>
              <h3>Stocks & Approvisionnement</h3>
              <p>Relations fournisseurs, renouvellement des produits, gestion et suivi rigoureux des inventaires.</p>
            </div>
          </div>

          <div className="bento-card card-with-img">
            <div className="card-media">
              <img src="https://images.unsplash.com/photo-1572116469696-31de0f17cc34?auto=format&fit=crop&w=600&q=80" alt="Service au bar" />
            </div>
            <div className="card-content">
              <span className="card-label">Leadership</span>
              <h3>Management & Fort Débit</h3>
              <p>Supervision et animation d'une équipe jusqu'à 15 personnes (restauration, bar, limonaderie) et conduite de services à très gros débit.</p>
            </div>
          </div>

          <div className="bento-card card-with-img">
            <div className="card-media">
              <img src="https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=600&q=80" alt="Ambiance Bar" />
            </div>
            <div className="card-content">
              <span className="card-label">Expérience Client</span>
              <h3>Service & Ambiance</h3>
              <p>Accueil et fidélisation de la clientèle, maintien des normes d'hygiène/sécurité et garantie d'un service fluide et chaleureux.</p>
            </div>
          </div>

        </div>
      </section>

      {/* Banner Visuel Intermédiaire */}
      <div className="hero-banner">
        <img src="https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1200&q=80" alt="Bar à cocktails" />
        <div className="banner-overlay">
          <span>« L'excellence du service réside dans le sens du détail »</span>
        </div>
      </div>

      {/* Expériences Professionnelles */}
      <section className="cv-section">
        <h2 className="section-title">Parcours Professionnel</h2>

        <article className="experience-card">
          <div className="exp-header">
            <div>
              <h3>Barman / Serveur (Responsable de bar par intérim)</h3>
              <span className="company">LES TONTONS NAGEURS</span>
            </div>
            <span className="date-pill">Mai 2025 – Aujourd’hui</span>
          </div>
          <ul className="exp-list">
            <li>Management d’une équipe d’une quinzaine de personnes (restauration / bar / limonaderie).</li>
            <li>Conduite et coordination de services à gros débit.</li>
            <li>Garant du bon fonctionnement général du bar et du respect des standards.</li>
          </ul>
        </article>

        <article className="experience-card">
          <div className="exp-header">
            <div>
              <h3>Barman / Serveur</h3>
              <span className="company">L’OLIVIER</span>
            </div>
            <span className="date-pill">Juin 2025 – Mai 2026</span>
          </div>
          <ul className="exp-list">
            <li>Service en salle et développement de la relation client.</li>
            <li>Relation avec les fournisseurs et gestion rigoureuse des stocks.</li>
            <li>Création de cocktails et création de la carte boissons.</li>
          </ul>
        </article>

        <article className="experience-card">
          <div className="exp-header">
            <div>
              <h3>Photographe Indépendant</h3>
              <span className="company">BREV PIXEL</span>
            </div>
            <span className="date-pill">Janvier 2026 – Août 2026</span>
          </div>
          <ul className="exp-list">
            <li>Prospection commerciale auprès de particuliers et de professionnels.</li>
            <li>Gestion des imprévus terrain et autonomie opérationnelle.</li>
            <li>Gestion administrative et suivi des dossiers.</li>
          </ul>
        </article>
      </section>

      {/* Formations */}
      <section className="cv-section">
        <h2 className="section-title">Formations & Parcours</h2>
        <div className="education-grid">

          <article className="edu-card">
            <div className="edu-badge">2026</div>
            <h3>Techniques de Management de Proximité</h3>
            <span className="school">Reso Formations</span>
            <ul className="edu-axes">
              <li>Communication managériale et posture de leader.</li>
              <li>Gestion et animation d'équipe au quotidien (briefs, motivation).</li>
              <li>Prévention et résolution des conflits en fort débit.</li>
            </ul>
          </article>

          <article className="edu-card">
            <div className="edu-badge">2026</div>
            <h3>Ouvrir et Gérer son Bar à Cocktail</h3>
            <span className="school">Massena Formations</span>
            <p className="edu-text">
              Étude du marché et de la concurrence, les tendances, l'importance des réseaux sociaux, création de cocktails et gestion fournisseurs.
            </p>
          </article>

          <article className="edu-card">
            <div className="edu-badge">2025</div>
            <h3>Développeur Web</h3>
            <span className="school">Openclassrooms</span>
            <p className="edu-text">
              Création de maquettes, apprentissage des langages JavaScript & PHP, réalisation de sites web et bases de données.
            </p>
          </article>

          <article className="edu-card">
            <div className="edu-badge">2020</div>
            <h3>Bac. Pro. Systèmes Numériques</h3>
            <span className="school">Lycée F. Arago — Nantes</span>
            <p className="edu-text">
              Apprentissage des bases en réseaux, équipements électroniques et systèmes informatiques.
            </p>
          </article>

        </div>
      </section>

      {/* Footer */}
      <footer className="cv-footer">
        <p>CV Numérique • Barman • Serveur • Manager</p>
      </footer>
    </div>
  );
}